import { render, staticRenderFns } from "./DuplicatePostSelectionModal.vue?vue&type=template&id=2f341f6e&"
import script from "./DuplicatePostSelectionModal.vue?vue&type=script&lang=js&"
export * from "./DuplicatePostSelectionModal.vue?vue&type=script&lang=js&"
import style0 from "./DuplicatePostSelectionModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports